<template>
  <!-- Demo Mode Badge -->
  <div
    v-if="isDemo"
    class="flex items-center gap-2 rounded-md bg-amber-500/10 px-3 py-2 dark:bg-amber-500/20"
  >
    <div class="flex items-center gap-1.5">
      <span class="text-sm font-medium text-brand-text dark:text-white">
        DEMO PROJECT
      </span>
    </div>
    <a
      href="/"
      class="text-xs underline font-bold text-brand-text dark:text-white opacity-80"
      title="Exit demo mode"
    >
      Exit
    </a>
  </div>

  <!-- Regular Team Selector -->
  <Select
    v-else
    class="w-[9rem] flex-grow"
    :options="teams"
    option-value="pid"
    option-label="name"
    :placeholder="currentTeam?.name || 'Select a team'"
    @change="selectTeam"
  >
    <template #value>
      <div class="flex items-center space-x-1.5">
        <div class="w-[100px] truncate text-sm text-black dark:text-white/80">
          <template v-if="!currentTeam">
            <span class="opacity-50">Select a project</span>
          </template>
          <template v-else>
            <template v-if="!doesOwnCurrentTeam">
              {{ currentTeam.name }}
            </template>
            <template v-else>
              <template v-if="currentTeam.name">
                {{ currentTeam.name }}
              </template>
              <template v-else>
                <span class="opacity-50">New team</span>
              </template>
            </template>
          </template>
        </div>
      </div>
    </template>
    <template #option="slotProps">
      <div class="block text-sm">
        <div class="flex items-center space-x-1.5">
          <img
            :src="`https://img.logo.dev/${slotProps.option.website}?token=pk_cZiWDpV1RAC_ml3vv_hAww&size=200`"
            class="h-6 w-6 rounded-full"
          >
          <span class="ml-2 text-base font-normal">
            {{ slotProps.option.name }}
          </span>
          <Tag
            v-if="slotProps.option.is_client_team"
            value="Client"
            severity="secondary"
            class="ml-1"
          />
          <span class="opacity-30">/</span>
          <span class="opacity-50">
            {{ slotProps.option.website }}
          </span>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="border-t border-gray-200 dark:border-gray-700">
        <button
          type="button"
          class="flex w-full items-center gap-2 px-3 py-2.5 text-sm text-primary-600 hover:bg-gray-100 dark:text-primary-400 dark:hover:bg-gray-800"
          @click="addNewProject"
        >
          <PlusIcon class="h-4 w-4" />
          <span>Add a new project</span>
        </button>
      </div>
    </template>
  </Select>

  <NewAccountDialog v-model="newAccountDialogVisible" />
</template>

<script setup lang="ts">
import { PlusIcon } from '@heroicons/vue/24/outline'
import NewAccountDialog from '@/modules/onboarding/components/NewAccountDialog.vue'

const router = useRouter()

const teamStore = useTeamStore()
const { teams, doesOwnCurrentTeam, isDemo } = storeToRefs(teamStore)

const configStore = useConfigStore()
const { currentTeam } = storeToRefs(configStore)

const newAccountDialogVisible = ref(false)

const selectTeam = ({ value }: { value: number }): void => {
  // Force a full page reload to avoid state issues
  window.location.href = `/${value}/dashboard`
}

const addNewProject = (): void => {
  newAccountDialogVisible.value = true
}
</script>
